import { useQuery } from "react-query";
import { getEmployees } from "../../../../../actions/Employees";

let employeeList = [];

export default function useGetEmployees() {
  const { data } = useQuery("GetEmployees", getEmployees, {
    refetchOnWindowFocus: false,

    onSuccess: (res) => {
      if (res) {
        if (res.statusCode === 500 || res.statusCode === 400) {
        } else {
          employeeList = res;
        }
      }
    },
  });
  return employeeList;
}
